import { render, staticRenderFns } from "./PerTonMetrics.vue?vue&type=template&id=05cd8c87&scoped=true&"
import script from "./PerTonMetrics.vue?vue&type=script&lang=js&"
export * from "./PerTonMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cd8c87",
  null
  
)

export default component.exports